import { createFileRoute, useRouter } from "@tanstack/react-router";

import { parsePromoSearch } from "@/features/growth";
import { PromoCodesPage } from "@/features/growth/pages";
import { strictSearch } from "@/shared/lib/search";

export const Route = createFileRoute("/_app/growth/promo-codes/")({
  validateSearch: strictSearch(parsePromoSearch),
  component: PromoCodes,
});

function PromoCodes() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  const router = useRouter();
  return (
    <PromoCodesPage
      search={search}
      onSearchChange={(next, options) =>
        void navigate({ search: next, replace: options?.replace === true })
      }
      hrefOf={(promoId) =>
        router.buildLocation({ to: "/growth/promo-codes/$promoId", params: { promoId } }).href
      }
      onOpen={(promoId) =>
        void router.navigate({ to: "/growth/promo-codes/$promoId", params: { promoId } })
      }
    />
  );
}
